import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const StatusUpdateResultModal = ({ show, onCloseClick, result }) => {
  if (!result) return null;

  const { status, summaryMessage, productsAdded, productsUpdated, productsErrorCount, failedProductUPCs } = result;

  const getIconByStatus = () => {
    switch (status) {
      case "Success":
        return {
          src: "https://cdn.lordicon.com/lomfljuq.json",
          colors: "primary:#121331,secondary:#08a88a",
        };
      case "Parcial":
        return {
          src: "https://cdn.lordicon.com/tdrtiskw.json",
          colors: "primary:#121331,secondary:#f7b84b",
        };
      case "Failed":
        return {
          src: "https://cdn.lordicon.com/tdrtiskw.json",
          colors: "primary:#121331,secondary:#f06548",
        };
      default:
        return {
          src: "https://cdn.lordicon.com/tdrtiskw.json",
          colors: "primary:#121331,secondary:#08a88a",
        };
    }
  };

  const icon = getIconByStatus();

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="lg">
      <ModalHeader toggle={onCloseClick}>Status Update Results</ModalHeader>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <lord-icon
            src={icon.src}
            trigger="loop"
            colors={icon.colors}
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4 className={`text-${status === "Success" ? "success" : status === "Parcial" ? "warning" : "danger"}`}>
              {status === "Success" ? "? Success" : status === "Parcial" ? "? Partial Success" : "? Failed"}
            </h4>
            <p className="text-muted mx-4 mb-3">{summaryMessage}</p>
          </div>
        </div>

        {/* Statistics Section */}
        {(productsAdded > 0 || productsUpdated > 0 || productsErrorCount > 0) && (
          <div className="border rounded p-3 mb-3 bg-light">
            <h6 className="mb-3">Summary</h6>
            <div className="row text-center">
              {productsAdded > 0 && (
                <div className="col-md-4">
                  <div className="p-2">
                    <div className="text-success fs-3 fw-bold">{productsAdded}</div>
                    <div className="text-muted small">Products Added</div>
                  </div>
                </div>
              )}
              {productsUpdated > 0 && (
                <div className="col-md-4">
                  <div className="p-2">
                    <div className="text-info fs-3 fw-bold">{productsUpdated}</div>
                    <div className="text-muted small">Products Updated</div>
                  </div>
                </div>
              )}
              {productsErrorCount > 0 && (
                <div className="col-md-4">
                  <div className="p-2">
                    <div className="text-danger fs-3 fw-bold">{productsErrorCount}</div>
                    <div className="text-muted small">Errors</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Failed UPCs Section */}
        {failedProductUPCs && failedProductUPCs.length > 0 && (
          <div className="border rounded p-3 mb-3 bg-light">
            <h6 className="text-danger mb-3">
              <i className="ri-error-warning-line me-2"></i>
              Failed Product UPCs ({failedProductUPCs.length})
            </h6>
            <div
              className="p-2 bg-white border rounded"
              style={{
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              <ul className="list-unstyled mb-0">
                {failedProductUPCs.map((upc, index) => (
                  <li key={index} className="py-1 px-2 border-bottom">
                    <code className="text-danger">{upc}</code>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn btn-primary px-4"
            onClick={onCloseClick}
          >
            Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

StatusUpdateResultModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  result: PropTypes.shape({
    status: PropTypes.oneOf(["Success", "Parcial", "Failed"]),
    summaryMessage: PropTypes.string,
    productsAdded: PropTypes.number,
    productsUpdated: PropTypes.number,
    productsErrorCount: PropTypes.number,
    failedProductUPCs: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default StatusUpdateResultModal;
